var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68989 12.2598V7.49525C5.68989 7.3928 5.64919 7.29453 5.57674 7.22209C5.50429 7.14964 5.40603 7.10894 5.30357 7.10894H0.539062M5.68989 12.2598H0.925374C0.822918 12.2598 0.724658 12.2191 0.652211 12.1466C0.579763 12.0742 0.539062 11.9759 0.539062 11.8735V7.10894M5.68989 12.2598H7.62144M0.539062 7.10894V5.17738M2.47062 0.67041H0.925374C0.822918 0.67041 0.724658 0.711111 0.652211 0.783558C0.579763 0.856006 0.539063 0.954266 0.539062 1.05672V2.60197M7.62144 0.67041H5.04603M12.1284 5.17738V7.75279M10.1969 0.67041H11.7421C11.8446 0.67041 11.9428 0.711111 12.0153 0.783558C12.0877 0.856006 12.1284 0.954266 12.1284 1.05672V2.60197M10.1969 12.2598H11.7421C11.8446 12.2598 11.9428 12.2191 12.0153 12.1466C12.0877 12.0742 12.1284 11.9759 12.1284 11.8735V10.3282M5.68989 5.17738H7.62144V7.10894",
    stroke: "white",
    strokeWidth: 1.0865,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/resize.41cf6ca6257612f9465e4b564dc7c70b.svg";
export { ForwardRef as ReactComponent };